export default class CardTab {

    constructor(
        public heading: string,
        public content: JSX.Element) {

        }
}
